import { Text, Heading, TextLinkButton } from 'braid-design-system';
import type { ComponentProps } from 'react';

import { Link } from 'src/components/Router/Link';

interface InlineNudgeProps {
  fieldToFocus: string;
  nudgeText: string;
  displayText: string;
  data: Record<string, string>;
  type: 'Heading' | 'Text';
  icon?: ComponentProps<typeof Text>['icon'];
  level?: ComponentProps<typeof Heading>['level'];
  size?: ComponentProps<typeof Text>['size'];
  component?: ComponentProps<typeof Heading>['component'];
}

export const InlineNudge = ({
  displayText,
  nudgeText,
  fieldToFocus: focusOn,
  data,
  type,
  level = '1',
  size = 'standard',
  icon,
  component = 'p',
}: InlineNudgeProps) => {
  const displayTextContent = (
    <span data-hj-masked data-automation={data.automation}>
      {displayText ? (
        displayText
      ) : (
        <Link
          card="personal-details"
          mode="EDIT"
          params={{ focusOn }}
          component={TextLinkButton}
        >
          {nudgeText}
        </Link>
      )}
    </span>
  );

  if (type === 'Heading') {
    return (
      <Heading level={level} component={component} icon={icon}>
        {displayTextContent}
      </Heading>
    );
  }

  return (
    <Text maxLines={1} icon={icon} size={size}>
      {displayTextContent}
    </Text>
  );
};
